import React, { useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import ConfirmationButton from '../../../app/components/ConfirmationButton';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { useNotifications } from '../../../common/hooks/useNotifications';

export const CompanyEndPackageLink = (props: {
  companyId: string;
  companyName?: string | null;
}) => {
  const spd = useSpdCore();
  const notifications = useNotifications();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const deleteExams = () => {
    if (props.companyId) {
      setIsLoading(true);
      notifications.onPromise(
        spd.companies
          .deleteExpectationExams(props.companyId)
          .finally(() => setIsLoading(false)),
      );
    }
  };

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div onClick={e => e.stopPropagation()}>
      <OverlayTrigger overlay={<Tooltip>Usuwanie oczekujących badań</Tooltip>}>
        <ConfirmationButton
          confirmation={`Czy na pewno usunąć wszystkie oczekujące badania powiązane z firmą ${props.companyName}?`}
          variant="outline-danger"
          onOK={() => deleteExams()}
          isLoading={isLoading}
        >
          Zakończ badania
        </ConfirmationButton>
      </OverlayTrigger>
    </div>
  );
};
